"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLastMileDeliveryPriceriteModule = createLastMileDeliveryPriceriteModule;
exports.state = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

var _moment = _interopRequireDefault(require("moment"));

var _getters = require("./getters");

var _actions = require("./actions");

var _mutations = require("./mutations");

var _constants = require("./constants");

var state = {
  selectedDriver: null,
  disableTruckList: [],
  trucks: [],
  bufferTrucks: [],
  selectedTruck: null,
  pagination: _constants.DEFAULT_PAGINATION,
  defaultPagination: _constants.DEFAULT_PAGINATION,
  defaultTableSize: _constants.DEFAULT_PAGE_SIZE,
  defaultOrderColumns: _constants.DEFAULT_ORDER_COLUMNS,
  selectedColumns: _constants.DEFAULT_ORDER_COLUMNS,
  orderColumns: [].toString().replace(/,/g, '|'),
  orderColumnTemplates: [],
  unassignedOrders: [],
  excludedOrders: [],
  includedOrders: [],
  selectedOrders: [],
  orderFilters: [],
  incidents: [],
  dateRangeOption: 'drop',
  // startDate: moment(new Date()).subtract(14, 'days').format('YYYY-MM-DD 00:00:00'),
  startDate: (0, _moment.default)(new Date()).format('YYYY-MM-DD 00:00:00'),
  endDate: (0, _moment.default)(new Date()).format('YYYY-MM-DD 23:59:59'),
  planDate: (0, _moment.default)(new Date()).format('YYYY-MM-DD'),
  tableLoading: true,
  plan: {},
  anyChanges: false,
  isPlanExists: false,
  defaultLocationType: 'pickup',
  locationType: null,
  orderLocationLists: [],
  selectedLocation: null,
  truckFilters: [],
  truckLoading: true,
  searchType: 'fuzzySearch',
  locations: [],
  toBeUnassignedOrderIds: [],
  failedOrders: [],
  isManualAssignLoading: false,
  isAutoAssignLoading: false,
  isAssignedDriverChanges: false,
  GLOBAL_ACTIVE_USERS: [],
  GLOBAL_SELECTED_ORDERS: [],
  GLOBAL_SELECTED_TRUCKS: [],
  isOccupied: false,
  occupyingUsername: '',
  occupyingRoute: '',
  removedTruckIds: []
};
exports.state = state;
var namespaced = true;
var LastMileDeliveryModule = {
  namespaced: namespaced,
  state: state,
  getters: _getters.getters,
  actions: _actions.actions,
  mutations: _mutations.mutations
};

function createLastMileDeliveryPriceriteModule() {
  return LastMileDeliveryModule;
}